import { useState } from "react";
import { BsImage } from "react-icons/bs";

export const ProductImage = ({ src, name, className = "" }) => {
  const [failed, setFailed] = useState(null);
  return <div className={`eats-product-image ${className}`}>
    {src && src !== failed ? <img src={src} alt={name} loading="lazy" onError={() => setFailed(src)} /> :
      <div className="eats-image-placeholder" role="img" aria-label={`Imagen no disponible de ${name}`}><BsImage aria-hidden="true" /></div>}
  </div>;
};
